import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { isEqual } from "lodash";
import React from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { CloseDialogButton } from "./closeButtonDialog";
import { CustomFooter } from "./customFooter";
import { language } from "language/default";
import { useDeleteBenchmark } from "hooks/use-delete-benchmark";
import { closeDialog } from "store/messages-dialog";
export const InsDeletePrivateBenchmarkDialogAction = () => {
    const dispatch = useDispatch(), [, deleteBenchmark] = useDeleteBenchmark();
    const messagesDialog = useSelector((state) => state.messagesDialog, isEqual);
    return React.createElement(CustomFooter, null,
        React.createElement(AuxButton, { label: language.en.common.delete, key: "main-delete-button", type: AuxButtonTypeEnum.DESTRUCTIVE_PRIMARY, onClick: () => {
                batch(() => {
                    const request = {
                        id: messagesDialog.customProp?.id,
                        isCustom: true
                    };
                    deleteBenchmark(request);
                    dispatch(closeDialog());
                });
            } }),
        React.createElement(CloseDialogButton, null));
};
